import React from "react";
import {confirmAlert} from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import connection from "./connection";
import moment from "moment";
import "moment-timezone";
import AccessTime from "../node_modules/@material-ui/icons/AccessTime";
import EstadoUtilizador from "./components/EstadoUtilizador";

let general = {
  estadosAcontecimento: {
    RASCUNHO: 0,
    SUBMETIDO: 5,
    PUBLICO: 10,
    REGISTOS_ABERTOS: 20,
    REGISTOS_FECHADOS: 30,
    REGISTOS_FINALIZADOS: 50,
    A_DECORRER: 60,
    FINALIZADO: 70,
    FECHADO: 80,
    RELATORIO_SUBMETIDO: 90,
    RELATORIO_ACEITE: 100
  },

  notificationManager: null,

  error: function (message, title, duration) {
    if (typeof message === "object") {
      message = message.message;
    }
    general.notificationManager.error(message, title, duration || 4500);
  },

  success: function (message, title, duration) {
    general.notificationManager.success(message, title, duration || 4000);
  },

  warning: function (message, title, duration) {
    general.notificationManager.warning(message, title, duration || 3000);
  },

  alert: function (message, title, button, action) {
    confirmAlert({
      customUI: ({onClose}) => {
        return (
          <div className='container react-confirm-alert-body'>
            {title && <h1>{title}</h1>}<p>{message}</p>
            <div style={{marginTop: '20px'}}>
              <a className={'update-btn'} onClick={() => {
                onClose();
                action && action()
              }}>{button || "Ok"}</a>
            </div>
          </div>
        )
      }
    });
  },

  firstAndLast: function (name) {
    if (!name || name === "") {
      return name;
    }
    let split = name.split(" ");
    return split.length > 1 ? split[0] + " " + split[split.length - 1] : name;
  },

  boolToLocale: function (bool) {
    return bool ? "Sim" : "Não";
  },

  filterTable: function (data, search, rows) {
    if (search && search !== "") {
      return data.filter(row => {
        let _rows = rows || Object.keys(row);
        let found = false;
        _rows.forEach((rterm) => {
          if (String(row[rterm]).toLowerCase().includes(search.toLowerCase())) {
            found = true;
          }
        });
        return found;
      });
    } else {
      return data;
    }
  },

  Renderers: {
    dateRenderer: (row, options) => {
      if (!options)
        options = {};

      let date = row;
      if (row && row.column)
        date = row.value;

      let timezone = general.guessTimezone();

      date = moment(date);
      let text = "Data inválida";
      if (date.isValid())
        text = date.format("DD/MM/YYYY" + (options.date_only ? "" : " [às] H:mm" + (options.full ? ":ss" : "")))
      else if (options.default)
        text = options.default;
      else
        date = null;

      return date ? (
        <span>{text}
          {!options.hide_timezone &&
            <small style={{whiteSpace: "pre"}}> (<span style={{top: 2, position: "relative"}}><AccessTime
              fontSize={"inherit"}/></span> {timezone.trans})</small>}
        </span>
      ) : (typeof options.default !== 'undefined' ? options.default : "Por definir");
    },
    userRenderer: (row) => {
      let user = row && row.column ? row.original[row.column.id] : row;
      if (!user)
        return "Por definir";
      return (
        <span className="clickable" onClick={() => {
          window.App.hist.push("/perfil/" + user.id);
        }}>{window.App.state.user.id === user.id ? "Eu" : <EstadoUtilizador nome={user.nome_curto || user.nome} estado={user.estado}/>}</span>
      );
    },
    modeloRenderer: (row) => {
      return (<span>{row.value.designacao}</span>)
    },
    notaRenderer: (row) => {
      return row.original.feedback == null ? "" : (
        <div style={{textAlign: "center"}}><strong>{row.value}</strong></div>);
    },
    boolRenderer: (row) => {
      return row.value ? "Sim" : "Não"
    }
  },

  generateColor: (str) => {
    /*eslint-disable no-unused-expressions */
    /*eslint-disable no-sequences */
    /*eslint-disable no-mixed-operators */
    const pSBC = (p, c0, c1, l) => {
      let r, g, b, P, f, t, h, i = parseInt, m = Math.round, a = typeof (c1) === "string";
      if (typeof (p) !== "number" || p < -1 || p > 1 || typeof (c0) !== "string" || (c0[0] !== 'r' && c0[0] !== '#') || (c1 && !a)) return null;
      if (!this.pSBCr) this.pSBCr = (d) => {
        let n = d.length, x = {};
        if (n > 9) {
          [r, g, b, a] = d = d.split(","), n = d.length;
          if (n < 3 || n > 4) return null;
          x.r = i(r[3] === "a" ? r.slice(5) : r.slice(4)), x.g = i(g), x.b = i(b), x.a = a ? parseFloat(a) : -1
        } else {
          if (n === 8 || n === 6 || n < 4) return null;
          if (n < 6) d = "#" + d[1] + d[1] + d[2] + d[2] + d[3] + d[3] + (n > 4 ? d[4] + d[4] : "");
          d = i(d.slice(1), 16);
          if (n === 9 || n === 5) x.r = d >> 24 & 255, x.g = d >> 16 & 255, x.b = d >> 8 & 255, x.a = m((d & 255) / 0.255) / 1000;
          else x.r = d >> 16, x.g = d >> 8 & 255, x.b = d & 255, x.a = -1
        }
        return x
      };
      h = c0.length > 9, h = a ? c1.length > 9 ? true : c1 === "c" ? !h : false : h, f = this.pSBCr(c0), P = p < 0, t = c1 && c1 !== "c" ? this.pSBCr(c1) : P ? {
        r: 0,
        g: 0,
        b: 0,
        a: -1
      } : {r: 255, g: 255, b: 255, a: -1}, p = P ? p * -1 : p, P = 1 - p;
      if (!f || !t) return null;
      if (l) r = m(P * f.r + p * t.r), g = m(P * f.g + p * t.g), b = m(P * f.b + p * t.b);
      else r = m((P * f.r ** 2 + p * t.r ** 2) ** 0.5), g = m((P * f.g ** 2 + p * t.g ** 2) ** 0.5), b = m((P * f.b ** 2 + p * t.b ** 2) ** 0.5);
      a = f.a, t = t.a, f = a >= 0 || t >= 0, a = f ? a < 0 ? t : t < 0 ? a : a * P + t * p : 0;
      if (h) return "rgb" + (f ? "a(" : "(") + r + "," + g + "," + b + (f ? "," + m(a * 1000) / 1000 : "") + ")";
      else return "#" + (4294967296 + r * 16777216 + g * 65536 + b * 256 + (f ? m(a * 255) : 0)).toString(16).slice(1, f ? undefined : -2)
    };
    let c = ((() => {
      let hash = 0;
      for (let i = 0; i < str.length; i++) hash = str.charCodeAt(i) + ((hash << 5) - hash);
      return hash;
    })() & 0x00FFFFFF).toString(16).toUpperCase();

    return pSBC(-0.1, pSBC(0.70, "#" + ("00000".substring(0, 6 - c.length) + c)));
    /*eslint-enable no-unused-expressions */
    /*eslint-enable no-sequences */
    /*eslint-enable no-mixed-operators */
  },
  openReport: async (url) => {
    const openWindow = window.open();
    openWindow.document.write("<h3 style='font-size: 30px; font-weight: 200; font-family: Helvetica Neue, Helvetica, Arial, sans-serif;text-align:center;height:95%;line-height:100vh;'>Por favor aguarde enquanto o relatório é gerado.</h3>");
    try {
      let result = await connection.get(url);
      if (result.success) {
        setTimeout(() => {
          openWindow.location.replace(connection.getBase() + result.url_relatorio);
        }, 100);
      } else {
        general.error("Por favor tente novamente mais tarde.", "Erro!");
      }
    } catch (e) {
      openWindow.close()
    }
  },

  guessTimezone() {
    let trad = {
      "Atlantic/Azores": "Açores",
      "Europe/Lisbon": "Portugal continental",
      "Atlantic/Madeira": "Madeira",
    };
    let timezone = moment.tz.guess();
    return {tz: timezone, trans: trad[timezone] || timezone};
  },

  pad(num, size) {
    num = num + "";
    let s = "000000000" + num;
    s = s.substr(s.length - size);
    return s.length < num.length ? num : s;

  },

  userHasPermission(permission) {
    permission += ".";
    let tokens = permission.split(".");
    let modulo = window.App.state.user && window.App.state.user.permissoes && window.App.state.user.permissoes.find((perm) => perm.modulo === tokens[0]);
    if (modulo)
      return modulo.operacoes.includes(tokens[1]);
    return false;
  },

  userHasType(...type) {
    return !!(window.App.state.user && window.App.state.user.tipos && window.App.state.user.tipos.filter((tipo) => type.includes(tipo.codigo)).length > 0)
  },

  T: (() => {
    let translations = {
      "formacao": "Formação"
    };
    return to_translate => translations[to_translate] || to_translate;
  })(),

  /**
   * https://stackoverflow.com/a/38806741
   * Takes a string phrase and breaks it into separate phrases
   * no bigger than 'maxwidth', breaks are made at complete words.
   */
  breakLabel: (str, maxwidth) => {
    let sections = [];
    let words = str.split(" ");
    let temp = "";

    words.forEach(function (item, index) {
      if (temp.length > 0) {
        let concat = temp + ' ' + item;

        if (concat.length > maxwidth) {
          sections.push(temp);
          temp = "";
        } else {
          if (index === (words.length - 1)) {
            sections.push(concat);
            return;
          } else {
            temp = concat;
            return;
          }
        }
      }

      if (index === (words.length - 1)) {
        sections.push(item);
        return;
      }

      if (item.length < maxwidth) {
        temp = item;
      } else {
        sections.push(item);
      }

    });

    return sections;
  }

};

window.general = general;

export default general;
